export const FACET_MADE_IN_AMERICA = 'characteristics_made_in_america';
export const FACET_COMPLIANCE = 'Compliance';
export const FACET_CONDITIONS = 'conditions';